import * as React from "react";
import Schedule from "./Schedule.tsx";
import ComboBox from "./ComboBox.tsx";
import { getTeacherNames, AddSchedule } from "./teacherAPI.ts";

interface ITeacherSchedule {
  state: boolean;
  setModalState: any;
}

export default function TeacherShedule({
  state,
  setModalState,
}: ITeacherSchedule) {
  const [TeacherList, setData] = React.useState<{}>({});
  const [isLoading, SetLoading] = React.useState(true);
  const [value, setValue] = React.useState<string>("");

  React.useEffect(() => {
    console.log(value);
  }, [value]);

  React.useEffect(() => {
    const fetchData = async () => {
      const res = await getTeacherNames();
      setData(res);
      SetLoading(false);
    };
    fetchData();
  }, [state]);

  return (
    <Schedule
      onSubmit={() => {
        AddSchedule(TeacherList, value);
      }}
      state={state}
      setScheduleState={setModalState}
    >
      <ComboBox
        type="text"
        suggestions={Object.values<string>(TeacherList)}
        placeholder="start typing"
        isLoading={isLoading}
        value={value}
        setValue={setValue}
      />
    </Schedule>
  );
}
